import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const GalleryImageList = Loadable(
  lazy(() => import("features/galleryImage/components/List"))
);

const routes = {
  path: "galleryImage",
  children: [{ path: "", element: <GalleryImageList /> }],
};

export default routes;
